// @core/api/endpoints/subscription/list_subscription_items.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListSubscriptionItemsResponse,
} from '../../../types/subscription';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/subscription';

/**
 * List subscription items
 * Returns all line items for a subscription including base plan, addons, seats, and metered components.
 */
export async function ListSubscriptionItems(
  subscription_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListSubscriptionItemsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/subscriptions/:subscription_id/items`;
  requestPath = requestPath.replace(':subscription_id', encodeURIComponent(subscription_id));
  const requestOptions = options;
  return client.get<ListSubscriptionItemsResponse>(requestPath, { ...requestOptions, params });
}
